import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "../components/ui/button";
import { useValiderPaiementSession } from "../lib/hooks/usePaiement";
import { ksAchatsQK, ksFacturesAPayerQK, ksFacturesQK } from "../lib/query-keys";

const SuccessProduitPage = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [validationTerminee, setValidationTerminee] = useState(!sessionId);
  const queryClient = useQueryClient();
  const { mutate: validerPaiementSession } = useValiderPaiementSession();

  useEffect(() => {
    if (!sessionId) {
      setValidationTerminee(true);

      return;
    }

    setValidationTerminee(false);

    validerPaiementSession(
      { sessionId },
      {
        onSettled: () => {
          queryClient.invalidateQueries({ queryKey: [ksAchatsQK] });
          queryClient.invalidateQueries({ queryKey: [ksFacturesQK] });
          queryClient.invalidateQueries({ queryKey: [ksFacturesAPayerQK] });
          setValidationTerminee(true);
        },
      }
    );
  }, [queryClient, sessionId, validerPaiementSession]);

  return (
    <div className="flex flex-col gap-3">
      Merci pour votre achat !
      <div>
        {validationTerminee ? (
          <Link to={"/boutique"}>
            <Button>Télécharger mes étiquettes dans la boutique</Button>
          </Link>
        ) : (
          <Button loading>Validation du paiement...</Button>
        )}
      </div>
    </div>
  );
};

export default SuccessProduitPage;
